<template>
<div class="odr-tab-navigation">
    <slot name="tabHeader"></slot>
    <div ref="tabContentWrapper" class="odr-tab-navigation__content">
        <slot name="tabContent"></slot>
    </div>
    <div class="odr-tab-navigation__footer">
        <span class="odr-tab-navigation__footer-error" v-if="acknowledgementError"> {{this.acknowledgementError}}</span>
    </div>
</div>
</template>

<script>
import '@/scss/blocks/tab-navigation.scss';
import { tabBus } from '@/utils/tab-bus';
import { mapGetters } from 'vuex';

export default {
    props: {
        'acknowledgement-mandatory': {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            activeIndex: 0,
        };
    },
    mounted () {
        this.setInitialActiveIndex();
        tabBus.$emit('tab-change', this.activeIndex); // Emit the initial active index
        tabBus.$on('tab-change', this.resetScroll);
    },
    beforeDestroy () {
        tabBus.$off('tab-change', this.resetScroll);
    },
    methods: {
        setInitialActiveIndex () {
            const tabHeader = this.$slots.tabHeader;
            if (tabHeader && tabHeader.length > 0) {
                const tabHeaderContent = tabHeader[0].componentOptions;
                if (tabHeaderContent && tabHeaderContent.children.length > 0) {
                    const firstTabHeaderItem = tabHeaderContent.children[0].componentInstance;
                    if (firstTabHeaderItem && firstTabHeaderItem.index !== undefined) {
                        this.activeIndex = firstTabHeaderItem.index;
                    }
                }
            }
        },
        resetScroll () {
            this.$refs.tabContentWrapper.scrollTo(0, 0);
        },
    },
    provide () {
        return {
            acknowledgementMandatory: this.acknowledgementMandatory,
        };
    },
    computed: {
        ...mapGetters('flow', {
            getAcknowledgement: 'getAcknowledgement',
        }),

        acknowledgementError () {
            const acknowledgementMandatory = this.getAcknowledgement(this.acknowledgementMandatory);
            if (acknowledgementMandatory && acknowledgementMandatory.showError) {
                return acknowledgementMandatory.eMessage || '';
            }
            return null;
        },
    },
};
</script>
